import {useEffect, useState} from 'react';
import {Card, Table} from 'antd';
import {ProductSearchWidget} from "../fulfillment/ProductSearchWidget";
import {QuantityEntryWidget} from "../fulfillment/QuantityEntryWidget";
import {TrashWidget} from "../widget/TrashWidget";
import {getProductIngredients, insertProductIngredient, deleteProductIngredient} from "../../api/Api";

export const PackagedIngredientsCard = ({product, onApiFail, refresh, onRefresh, props}) => {
    const [ingredients, setIngredients] = useState([]);

    useEffect(() => {
        getProductIngredients(product.id).then(result => {
            setIngredients(result.map(r => {
                return {
                    ...r,
                    key: r.ingredientId
                }
            }));
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        });
    }, [product.id, refresh, onApiFail])
    const onSelect = (item) => {
        insertProductIngredient(product.id, item.id, 1).then(r => {
            if (onRefresh) onRefresh();
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        });
    }

    const onQuantityChange = (record) => (val) => {
        insertProductIngredient(product.id, record.ingredientId, val).then(r => {
            if (onRefresh) onRefresh();
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        });
    }

    const onDelete = (record) => () => {
        deleteProductIngredient(record.productId, record.ingredientId).then(r => {
            if (onRefresh) onRefresh();
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        });
    }

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Ratio',
            dataIndex: 'ratio',
            key: 'ratio',
            render: (val, record, index) => {
                return <QuantityEntryWidget onQuantityChange={onQuantityChange(record)}
                    title={`${record.name} Ratio`}
                    unit={record.unit} value={val} />
            }
        },
        {
            title: 'Delete',
            dataIndex: 'id',
            key: 'delete',
            render: (val, record, index) => {
                return <TrashWidget onDelete={onDelete(record)} />
            }
        }
    ]

    const cardStyle = {textAlign: 'left'}

    return <Card style={cardStyle} title={<b>Ingredients</b>}>
        {ingredients.length > 0 &&
        <Table columns={columns} dataSource={ingredients} pagination={false} />
        }
        <ProductSearchWidget onSelect={onSelect} onApiFail={onApiFail} refresh={refresh} type={"all"} />
    </Card>
}